/**
 * Returns a promise with passed delay (default’s to 1000)
 */
const sleep = (delay: number = 1000): Promise<undefined> =>
  new Promise((resolve) => setTimeout(resolve, delay))


export default sleep
